import { BreadCrumb } from 'primereact/breadcrumb';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

const ReportHubBreadcrumb: FC = () => {
  const navigate = useNavigate();

  const home = { icon: 'nc_icon-nc_home icon-sm', command: () => navigate('/') };
  const breadcrumbItems = [
    { label: 'Monitor', command: () => navigate('/quick-data') },
    { label: 'Reports Hub', command: () => navigate('/reports-hub') },
  ];

  return <BreadCrumb model={breadcrumbItems} home={home} className="col-12 nc_breadcrumb" />;
};

export default ReportHubBreadcrumb;
